export default __webpack_public_path__ + "static/AMA20 Finalist Medal_Broker of the Year - Commercial-a773a271bda9865aa4ccdb6b3491f229.png";